import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/address_book/create',
    name: 'create_warehouse',
    component: () => import('@/views/pages/address-book/CreateAddressBook.vue'),
    meta: {
      pageTitle: 'Create Address Book',
      breadcrumb: {
        label: 'Create Address Book',
        parent: 'address_book'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  },
  {
    path: '/address_book/:id',
    name: 'address_book_detail',
    component: () => import('@/views/pages/address-book/EditAddressBook.vue'),
    meta: {
      pageTitle: 'Edit Address Book',
      breadcrumb: {
        label: 'Edit Address Book',
        parent: 'address_book'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  },
  {
    path: '/address_book',
    name: 'address_book',
    component: () => import('@/views/pages/address-book/AddressBookList.vue'),
    meta: {
      pageTitle: 'Address Book',
      breadcrumb: {
        label: 'Address Book'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER],
      verticalMenu: {
        title: 'Address Book',
        icon: 'HomeIcon'
      }
    }
  }
];
